export * from './device-details-breadcrumbs.component';
